export enum ClientType {
    General = 0,
    PAC = 1
}
